import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { matchConsolidationDetailRoutePath } from '@futrli/shared-services';

import { CreateBudgetWizardContainer } from '../containers/create-budget-wizard-container/create-budget-wizard-container';
import { CreateConsolidatedBudgetWizardContainer } from '../containers/create-consolidated-budget-wizard-container/create-consolidated-budget-wizard-container';
import { CreateConsolidatedForecastWizardContextProvider } from '../contexts/create-consolidated-forecast-wizard-context';
import { CreateForecastWizardContextProvider } from '../contexts/create-forecast-wizard-context';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const CreatePAndLBudgetSidebar = ({ isOpen, onClose }: Props) => {
  const isConsolidation = !!matchConsolidationDetailRoutePath(window.location.pathname);

  return (
    <Sidebar
      header={
        <Typography variant="h2" fontWeight="700">
          <FormattedMessage id="predict.create_forecast.create_budget_title_v2" defaultMessage="Create a P&L budget" />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
    >
      {isConsolidation ? (
        <CreateConsolidatedForecastWizardContextProvider kind="budget">
          <CreateConsolidatedBudgetWizardContainer onClose={onClose} />
        </CreateConsolidatedForecastWizardContextProvider>
      ) : (
        <CreateForecastWizardContextProvider kind="budget">
          <CreateBudgetWizardContainer onClose={onClose} />
        </CreateForecastWizardContextProvider>
      )}
    </Sidebar>
  );
};
